import type { ReactNode } from "react";
import { Star } from "lucide-react";

import { Card } from "@/components/ui/card";

interface Props {
  title: string;
  children: ReactNode;
}

export function ProUpsellCard({ title, children }: Props) {
  return (
    <Card className="flex items-start gap-3 border-primary/30 bg-primary/5 p-4">
      <Star
        className="mt-0.5 size-5 shrink-0 fill-primary text-primary"
        aria-hidden="true"
      />
      <div className="min-w-0 space-y-1 text-sm text-muted-foreground">
        <strong className="block font-semibold text-foreground">{title}</strong>
        {children}
      </div>
    </Card>
  );
}
